import { PrvIf } from './preview.types'

export const prvIf: PrvIf = (isPreview) => (isPreview ? '/prv' : '')
